import React from "react";

const MutedInSpace = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.14844 11.5479V14.5069" stroke="black" />
      <path
        d="M5.48438 8.21777C5.48438 12.6563 12.8121 12.6563 12.8121 8.21777"
        stroke="black"
      />
      <path
        d="M11.3863 4.90896C11.3863 3.67237 10.3838 2.66992 9.14724 2.66992C7.91066 2.66992 6.9082 3.67237 6.9082 4.90896V7.82842C6.9082 9.06501 7.91066 10.0675 9.14724 10.0675C10.3838 10.0675 11.3863 9.06501 11.3863 7.82842V4.90896Z"
        fill="black"
      />
      <path
        d="M15.8136 13.2555L3.98047 2.45215L2.76277 3.78592L14.5959 14.5892L15.8136 13.2555Z"
        fill="black"
      />
    </svg>
  );
};

export default MutedInSpace;
